import { render, staticRenderFns } from "./wx_resume.vue?vue&type=template&id=093121da&scoped=true&"
import script from "./wx_resume.vue?vue&type=script&lang=js&"
export * from "./wx_resume.vue?vue&type=script&lang=js&"
import style0 from "./wx_resume.vue?vue&type=style&index=0&id=093121da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093121da",
  null
  
)

export default component.exports